import React, { useRef } from 'react';
import { AriaButtonProps } from '@react-aria/button';
import { useHover } from '@react-aria/interactions';
import { filterDOMProps, mergeProps } from '@react-aria/utils';
import clsx from 'clsx';
import styles from '@danske/sapphire-css/components/dateField/dateField.module.css';
import { useFocusRing } from '@react-aria/focus';
import { useButton } from '../../utils';

/**
 * @internal
 */
export const DateFieldButton = (
  props: AriaButtonProps & { isClearButton?: boolean }
) => {
  const ref = useRef(null);
  const { buttonProps, isPressed } = useButton(props, ref);
  const { hoverProps, isHovered } = useHover({ isDisabled: props.isDisabled });
  const { focusProps, isFocusVisible } = useFocusRing();

  return (
    <button
      {...mergeProps(
        buttonProps,
        hoverProps,
        focusProps,
        filterDOMProps(props, { global: true })
      )}
      ref={ref}
      className={clsx(
        styles['sapphire-date-field__button'],
        styles['js-focus'],
        styles['js-hover'],
        {
          [styles['is-active']]: isPressed,
          [styles['is-hover']]: isHovered,
          [styles['is-focus']]: isFocusVisible,
          [styles['sapphire-date-field__button--clear']]: props.isClearButton,
        }
      )}
    >
      {props.children}
    </button>
  );
};
